import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-radio-input',
	templateUrl: './radio-input.component.html',
	styleUrls: ['./radio-input.component.scss'],
	host: {
		class: 'app-radio-input'
	}
})
export class RadioInputComponent implements OnInit {

	constructor() { }

	@Input() selected: boolean;
	@Input() label: string;
	@Input() id: string;
	@Input() name: string;
	@Input() hideLabel: boolean = false;
	@Input() visualOnly: boolean = false;
	
	@Output() radioChanged = new EventEmitter();

	ngOnInit() {
	}

	toggleValue() {
		if (this.visualOnly) return;
		
		const emitted: any = {};
		this.selected = true;
		emitted[this.id] = this.selected;
		this.radioChanged.emit(emitted);
	}

	emitChange() {
		this.toggleValue();
	}
}
